/**
 * Studio avatar-selection IDs. Button 4 / Stefan is the avatar host default
 * after a fresh iframe load.
 */

export const AVATAR_IDS = Object.freeze({
  COOPER: '10000',
  AVATAR_2: '10001',
  AVATAR_3: '10002',
  STEFAN: '10003',
});

export const STEFAN_AVATAR_ID = AVATAR_IDS.STEFAN;
export const DEFAULT_AVATAR_ID = STEFAN_AVATAR_ID;

const AVATAR_ID_SET = new Set(Object.values(AVATAR_IDS));

export function normalizeAvatarId(value) {
  const s = String(value);
  return AVATAR_ID_SET.has(s) ? s : DEFAULT_AVATAR_ID;
}

export function shouldNotifyAvatarReload(previousSrc, nextSrc) {
  return typeof nextSrc === 'string' && nextSrc.length > 0 && previousSrc !== nextSrc;
}
